export const parseLiquidJSON = (str) => {
  return JSON.parse(decodeURIComponent(str.replace(/\+/g, " ")));
};
